module.exports = __webpack_public_path__ + "assets/img/main-btob-massive.7b3944fc.png";